// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getLoginToken, getCorpId } from "src/utils/token";
import queryString from "query-string";
import { setIsLogin, setErrorCode } from "src/store/features/teamUser";
import { message, Modal } from "antd";
import { TrackerSend } from "src/utils/tracker";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers, { getState }) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
    const token = getLoginToken();
    if (token) {
      headers.set("authorization", token);
    }
    const corpId = getCorpId();
    if (corpId) {
      headers.set("corpId", corpId);
    }
    return headers;
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

// 处理返回结果
const baseQueryHandleResult = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    const { status, originalStatus = "", error } = result?.error;
    const errorMessage = result?.error?.data?.message;
    const code = result?.error?.data?.code;

    // 弹出接口报错信息
    if (code === 20500) {
      Modal.error({
        title: "简历阶段进入失败",
        content: errorMessage,
      });
    } else {
      message.error(errorMessage || `服务错误 ${status} ${originalStatus}`);
    }

    const { request } = result.meta;
    // logger("baseQueryWithReauth", result);
    // logger(args, api, extraOptions)
    TrackerSend({
      errorType: "requestError",
      status,
      originalStatus,
      error,
      message: errorMessage,
      url: request?.url,
      method: request?.method,
      body: args?.body,
    });

    api.dispatch(setErrorCode(originalStatus));
    if (originalStatus === 401) {
      // 未登录
      api.dispatch(setIsLogin(false));
    }
  }
  return result;
};

// document https://redux-toolkit.js.org/rtk-query/overview
// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryHandleResult,
  endpoints: () => ({}),
});
